import React from 'react';
import { components, SingleValueProps } from 'react-select';
import { MarginProps } from '../../../theme/styledProps';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Select } from '../../../CommonComponents/OPL/Select/Select/Select';
import { useEntitySelect } from './useEntitySelect';
import { usePortfolioReportCache } from '../../api/usePortfolioReportParamsQuery';

const SingleValue: React.FC<SingleValueProps<any>> = ({ children, ...rest }) => {
  const text = rest.hasValue ? `${rest.data.label} • ${rest.data.subLabel}` : children;

  return <components.SingleValue {...rest}>{text}</components.SingleValue>;
};

interface Props extends MarginProps {
  paramId: string;
  selectedEntityType: string | null;
  dateRangeParamId: string | null;
}

export const EntitySelect: React.FC<Props> = ({
  dateRangeParamId,
  paramId,
  selectedEntityType,
  ...rest
}) => {
  const { data } = useEntitySelect({ paramId, selectedEntityType });

  const { mutateParamCache, mutateInceptionDate } = usePortfolioReportCache();

  if (!data) {
    return null;
  }

  const { selectedOption, options, placeholder } = data;

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Wrapper {...rest}>
      <Select
        value={selectedOption}
        options={options}
        variant="icon"
        onChange={option => {
          if (option) {
            mutateParamCache(paramId, { values: [option.value] });

            if (dateRangeParamId) {
              mutateInceptionDate(dateRangeParamId, option.inceptionDate);
            }
          }
        }}
        placeholder={placeholder}
        components={{
          SingleValue,
        }}
      />
    </Wrapper>
  );
};
